export default {
  setLanguage(language) {
    this.localeModel.instance = this.localeList.instance.find(
      (l) => l.value === language
    );
  },
};
